const DEFAULT_INPUT_TIMEOUT = 3000;

class EventSystem {
  events = {};
  recycledTimeouts = {};

  waitFor(waitTag, condition, action, waiting) {
    if (typeof waitTag === 'function') {
      action = condition;
      condition = waitTag;
      waitTag = 'unnamed wait';
    }
    if (condition())
      action();
    else {
      if (typeof waiting === 'undefined') waiting = 1; else waiting++;
      //if(waiting % 1000 ===0)console.log(`${waitTag} ${Math.round(waiting/1000)}sec`);
      setTimeout(() => this.waitFor(waitTag, condition, action, waiting), 1);
    }
  }
  RecycledTimeout(tag, action, interval) {
    if (tag in this.recycledTimeouts)
      clearTimeout(this.recycledTimeouts[tag]);
    this.recycledTimeouts[tag] = setTimeout(() => {
      action();
      delete this.recycledTimeouts[tag];
    }, interval);
  }
  RemoveTimeout(tag) {
    if (tag in this.recycledTimeouts) {
      clearTimeout(this.recycledTimeouts[tag]);
      delete this.recycledTimeouts[tag];
    }
  }
  unsubscribe(name, action) {
    if (name in this.events) {
      this.events[name] = this.events[name].filter(e => e !== action);
    }
  }
  unsubscribeAll(name) {
    this.events[name] = [];
  }
  subscribe(name, action) {
    if (!(name in this.events)) {
      this.events[name] = [action];
    } else {
      this.events[name].push(action);
    }
  }
  publish(name, params) {
    if (name in this.events) {
      this.events[name].forEach(a => a(params));
    }
  }
};
var eventSystem = new EventSystem();

export default eventSystem;
